import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cookie-consent"
}
const _hoisted_2 = { class: "cookie-consent__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_card, { class: "hk-card cookie-consent__card pa-5" }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "cookie-consent__text" }, [
              _createElementVNode("div", { class: "cookie-consent__title" }, "Sütik használata"),
              _createElementVNode("p", { class: "cookie-consent__body" }, " Hirdetéseink teljesítményének mérésére sütiket használnánk. Ezek nélkül az oldal ugyanúgy működik – csak nem látjuk, hogy a hirdetéseink elérik-e a céljukat. ")
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_btn, {
                variant: "text",
                color: "secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.decide('denied')))
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Elutasítom")
                ])),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.decide('granted')))
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Elfogadom")
                ])),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}